export default "__VITE_ASSET__DppYxFIz__"